import axiosInstance from "../../axiosInstance";
import {
  dispatchError,
  dispatchSuccess,
  loadingDispatch,
} from "../../DispatchFunctions";
import {
  CATCH_ERROR_MSG,
  ERROR_GET_BILL_HISTORY,
  GET_BILL_HISTORY,
  ERROR_GET_CARD_LIST,
  GET_CARD_LIST,
  SUCCESS_GET_CARD_LIST,
  SUCCESS_GET_BILL_HISTORY,
} from "../../Types";
import {
  getBillHistoryRequestUrl,
  getDirectPayCardListRequestUrl,
} from "../../URL";

export default function getBillHistory(telephoneNo, accountNo) {
  let url =
    getBillHistoryRequestUrl +
    "telephoneNo=" +
    telephoneNo +
    "&accountNo=" +
    accountNo;

  return (dispatch) => {
    dispatch(loadingDispatch(GET_BILL_HISTORY));
    axiosInstance
      .get(url)
      .then((response) => {
        if (response.status === 200 && response.data.isSuccess) {
          dispatch(
            dispatchSuccess(SUCCESS_GET_BILL_HISTORY, response.data.dataBundle)
          );
        } else {
          dispatch(
            dispatchError(ERROR_GET_BILL_HISTORY, response.data.errorShow)
          );
        }
      })
      .catch((error) => {
        dispatch(dispatchError(ERROR_GET_BILL_HISTORY, CATCH_ERROR_MSG));
      });
  };
}

export function numberWithCommas(x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function getCardList(user_name, wallet_id, eventsource) {
  let url = getDirectPayCardListRequestUrl;

  const formData = new URLSearchParams();
  formData.append("user_name", user_name);
  formData.append("wallet_id", wallet_id);
  formData.append(
    "eventsource",
    eventsource != null && eventsource !== ""
      ? String(eventsource)
      : localStorage.getItem("selectedAcc") || ""
  );

  return (dispatch) => {
    dispatch(loadingDispatch(GET_CARD_LIST));
    axiosInstance
      .post(url, formData.toString(), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.isSuccess) {
          dispatch(dispatchSuccess(SUCCESS_GET_CARD_LIST, response.data.data));
        } else {
          dispatch(
            dispatchError(
              ERROR_GET_CARD_LIST,
              response.data.errorShow || "Failed to fetch cards"
            )
          );
        }
      })
      .catch((error) => {
        dispatch(dispatchError(ERROR_GET_CARD_LIST, CATCH_ERROR_MSG));
      });
  };
}
